// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__JXob7","loaderActive":"loading_loaderActive__+4oHu","loader_spinner":"loading_loader_spinner__FEDSk","spin":"loading_spin__X9Z3Q"};